module.exports = __webpack_public_path__ + "static/media/minimalize.515db8c5.svg";